import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export const enum PAGEOBJECTTYPE {
  Object = 0,
  Text = 1,
  Image = 2,
  Sound = 3,
  Button = 4,
  Selection = 5,
  Input = 6,
  Evaluation = 8,
  Video = 9,
  UploadButton = 10,
  Container = 11,
  List = 12,
  Arrow = 13,
  Link = 14,
}

export class PageObject {
  protected _type: PAGEOBJECTTYPE;
  name: string;
  x: number;
  y: number;
  z: number;
  width: number;
  height: number;
  lock: boolean;
  visible: boolean;

  constructor(obj: PageObject = null) {
    if (obj == null) {
      this._type = PAGEOBJECTTYPE.Object;
      this.name = "";
      this.x = 0;
      this.y = 0;
      this.z = 0;
      this.width = 100;
      this.height = 100;
      this.lock = false;
      this.visible = true;
    } else {
      this._type = obj._type;
      this.name = obj.name;
      this.x = obj.x;
      this.y = obj.y;
      this.z = obj.z;
      this.width = obj.width;
      this.height = obj.height;
      this.lock = obj.lock;
      this.visible = obj.visible;
    }
  }

  get type(): PAGEOBJECTTYPE {
    return this._type;
  }

  private getObjectTypeString(type: PAGEOBJECTTYPE): string {
    switch (type) {
      case PAGEOBJECTTYPE.Object:
        return "Object";
      case PAGEOBJECTTYPE.Text:
        return "Text";
      case PAGEOBJECTTYPE.Link:
        return "Link";
      case PAGEOBJECTTYPE.Image:
        return "Image";
      case PAGEOBJECTTYPE.Sound:
        return "Sound";
      case PAGEOBJECTTYPE.Button:
        return "Button";
      case PAGEOBJECTTYPE.Selection:
        return "Selection";
      case PAGEOBJECTTYPE.Input:
        return "Input";
      case PAGEOBJECTTYPE.Evaluation:
        return "Evaluation";
      case PAGEOBJECTTYPE.Video:
        return "Video";
      case PAGEOBJECTTYPE.UploadButton:
        return "Upload Button";
      case PAGEOBJECTTYPE.Container:
        return "Container";
      case PAGEOBJECTTYPE.List:
        return "List";
      case PAGEOBJECTTYPE.Arrow:
        return "Arrow";
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = [];

    list.push(new ObjectProperty("Type", OBJECTPROPERTYTYPE.Text, false));
    list.push(new ObjectProperty("Name", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Position X", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Position Y", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Position Z", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Width", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Height", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Lock", OBJECTPROPERTYTYPE.Boolean));
    list.push(new ObjectProperty("Visible", OBJECTPROPERTYTYPE.Boolean));

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Type") {
      return this.getObjectTypeString(this._type);
    } else if (name == "Name") {
      return this.name;
    } else if (name == "Position X") {
      return Math.round(this.x);
    } else if (name == "Position Y") {
      return Math.round(this.y);
    } else if (name == "Position Z") {
      return Math.round(this.z);
    } else if (name == "Width") {
      return Math.round(this.width);
    } else if (name == "Height") {
      return Math.round(this.height);
    } else if (name == "Lock") {
      return this.lock;
    } else if (name == "Visible") {
      return this.visible;
    }

    return "Invalid Property";
  }

  setPropertyValue(name: string, value: any, style: string): void {
    if (name == "Name") {
      this.name = value;
    } else if (name == "Position X") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.x = newValue;
      }
    } else if (name == "Position Y") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.y = newValue;
      }
    } else if (name == "Position Z") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.z = newValue;
      }
    } else if (name == "Width") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.width = newValue;
      }
    } else if (name == "Height") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.height = newValue;
      }
    } else if (name == "Lock") {
      this.lock = value == "true";
    } else if (name == "Visible") {
      this.visible = value == "true";
    }
  }
}
